@if (iconProps !== null) {
    <nz-icon
        [nzType]="iconProps.iconType"
        [style]="iconProps.style"
        nz-popover
        [nzPopoverTitle]="popover?.title"
        [nzPopoverContent]="popover?.content"
        [nzRotate]="rotate"
        nzPopoverPlacement="right"></nz-icon>
}
